// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs {
  display: flex;
  border-bottom: 1px solid #e3e3e3;
  gap: 40px;
  margin-left: 40px;
  margin-right: 40px;
  font-family: "Montserrat Regular";
  overflow-x: auto;
}

.tablink {
  background-color: inherit;
  border: none;
  cursor: pointer;
  color: #898989;
  transition: background-color 0.3s;
  font-size: 16px;
  outline: none;
}

.tablink.active {
  color: #000000;
  border-bottom: 2px solid #e621d3;
}

.tabcontent {
  margin-top: 32px;
  align-items: center;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.tabcontent h3 {
  margin-top: 0;
  font-family: "Montserrat Regular";
}

.tabcontent p {
  margin-top: 0;
  font-family: "Montserrat Regular";
}

@media (max-width: 768px) {
  .tabs {
    gap: 10px;
    margin-left: 10px;
    padding: 5px 0;
  }
  .tablink {
    font-size: 14px;
    padding: 8px 12px;
  }
  .tabcontent {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsUpdatePage/Tabs/tabs.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gCAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;AACJ;;AAEE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;AACJ;;AAEE;EACE,cAAA;EACA,gCAAA;AACJ;;AAEE;EACE,gBAAA;EACA,mBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEE;EACE,aAAA;EACA,iCAAA;AACJ;;AAEE;EACE,aAAA;EACA,iCAAA;AACJ;;AAEE;EACE;IACE,SAAA;IACA,iBAAA;IACA,cAAA;EACJ;EAEE;IACE,eAAA;IACA,iBAAA;EAAJ;EAGE;IACE,aAAA;EADJ;AACF","sourcesContent":[".tabs {\n    display: flex;\n    border-bottom: 1px solid #e3e3e3;\n    gap: 40px;\n    margin-left: 40px;\n    margin-right: 40px;\n    font-family: \"Montserrat Regular\";\n    overflow-x: auto;\n  }\n  \n  .tablink {\n    background-color: inherit;\n    border: none;\n    cursor: pointer;\n    color: #898989;\n    transition: background-color 0.3s;\n    font-size: 16px;\n    outline: none;    \n  }\n  \n  .tablink.active {\n    color: #000000;\n    border-bottom: 2px solid #e621d3;\n  }\n  \n  .tabcontent {\n    margin-top: 32px;\n    align-items: center;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .tabcontent h3 {\n    margin-top: 0;\n    font-family: \"Montserrat Regular\";\n  }\n\n  .tabcontent p {\n    margin-top: 0;\n    font-family: \"Montserrat Regular\";\n  }\n  \n  @media (max-width: 768px) {\n    .tabs {\n      gap: 10px;\n      margin-left: 10px;\n      padding: 5px 0;\n    }\n  \n    .tablink {\n      font-size: 14px;\n      padding: 8px 12px;\n    }\n  \n    .tabcontent {\n      padding: 15px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `tabs`,
	"tablink": `tablink`,
	"active": `active`,
	"tabcontent": `tabcontent`
};
export default ___CSS_LOADER_EXPORT___;
